import { memo } from 'react';
import type { IIconProps } from '../interfaces';

const UsersIcon = (props: IIconProps) => {
  const { width = 24, height = 24, color = 'currentColor' } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.25 15C10.9424 15 13.125 12.8174 13.125 10.125C13.125 7.43261 10.9424 5.25 8.25 5.25C5.55761 5.25 3.375 7.43261 3.375 10.125C3.375 12.8174 5.55761 15 8.25 15Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M14.5683 5.42813C14.9992 5.31124 15.4437 5.25136 15.8902 5.25C17.1831 5.25 18.4231 5.76361 19.3373 6.67785C20.2516 7.59209 20.7652 8.83207 20.7652
        10.125C20.7652 11.4179 20.2516 12.6579 19.3373 13.5721C18.4231 14.4864 17.1831 15 15.8902 15"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 18.506C2.2612 17.4228 3.27191 16.5387 4.44676 15.9284C5.6216 15.3181 6.92608 14.9995 8.25 14.9995C9.57392 14.9995
         10.8784 15.3181 12.0532 15.9284C13.2281 16.5387 14.2388 17.4228 15 18.506"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8895 15C17.2136 14.9992 18.5183 15.3174 19.6933 15.9277C20.8682 16.5381 21.8788 17.4225 22.6395 18.5063"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default memo(UsersIcon);
